import type { CropRect } from "./types";

// Schneidet ein Rechteck aus einem ImageData aus. rect ist NORMALISIERT (0..1)
// relativ zur Bildgröße – so ist der Ausschnitt unabhängig von der
// Vorschau-Auflösung in der UI. Der Bereich wird auf die Bildgrenzen geklemmt.
export function cropToRect(img: ImageData, rect: CropRect): ImageData {
  const x = Math.max(0, Math.round(rect.x * img.width));
  const y = Math.max(0, Math.round(rect.y * img.height));
  const w = Math.min(Math.round(rect.w * img.width), img.width - x);
  const h = Math.min(Math.round(rect.h * img.height), img.height - y);
  if (w <= 0 || h <= 0) throw new Error("Ungültiger Zuschnitt-Bereich");

  const src = new OffscreenCanvas(img.width, img.height);
  const srcCtx = src.getContext("2d");
  if (!srcCtx) throw new Error("Kein 2D-Kontext (Crop-Source)");
  srcCtx.putImageData(img, 0, 0);

  const dest = new OffscreenCanvas(w, h);
  const destCtx = dest.getContext("2d");
  if (!destCtx) throw new Error("Kein 2D-Kontext (Crop-Ziel)");
  destCtx.drawImage(src, x, y, w, h, 0, 0, w, h);

  return destCtx.getImageData(0, 0, w, h);
}

// Größtes zentriertes Rechteck mit gegebenem Seitenverhältnis, normalisiert (0..1).
export function centerCropForAspect(imgW: number, imgH: number, aspect: number): CropRect {
  if (imgW / imgH > aspect) {
    const nw = (imgH * aspect) / imgW;
    return { x: (1 - nw) / 2, y: 0, w: nw, h: 1 };
  }
  const nh = imgW / aspect / imgH;
  return { x: 0, y: (1 - nh) / 2, w: 1, h: nh };
}
